export default __webpack_public_path__ + "static/media/akami.a92e2910.svg";